import httpUtil from '../utils/httpUtil.js'
import EventBus from '../utils/EventBus.js'

// 收货地址管理， 提供收货地址的增、删、改、查方法。

/**
 * 查
 * 注意：方法均不直接返回数据，获取获取此数据的页面只需要订阅 ADDRESS_LIST_GET 事件即可
 */
function getAddressList(
  additional = {
    refreshReason: 'getList',
  },
  callback = undefined
) {
  httpUtil.link(
    'customeraddresses',
    'GET',
    {},
    true,
    function (success, res, tips) {
      EventBus.send(EventBus.names.ADDRESS_LIST_GET, {
        success: success,
        res: res,
        tips: tips,
        additional: additional,
      }, true)
      if(callback){
        callback()
      }
    }
  )
}

/**
 * 增
 */
function addAddress(addressObj, callback) {
  httpUtil.link(
    'addressadd',
    'POST',
    JSON.stringify(addressObj),
    true,
    function (success, res, tips) {
      if (success) {
        getAddressList({
          refreshReason: 'addNew',
          id: parseInt(res.data.Content),
        },()=>{
          callback(
            success,
            success ? res.data.Content : {},
            success ? '添加成功' : tips
          )
        })
      } else {
        callback(
          success,
          success ? res.data.Content : {},
          success ? '添加成功' : tips
        )
      }
    }
  )
}

/**
 * 删
 */
function deleteAddress(addressId, callback) {
  httpUtil.link(
    {
      apiName: 'addressdelete',
      addressId: addressId,
    },
    'POST',
    {},
    true,
    function (success, res, tips) {
      if (success) {
        getAddressList({
          refreshReason: 'delete',
          id: parseInt(addressId),
        },()=>{
          if (callback) callback(success, res, success ? '已删除' : tips)
        })
      } else {
        if (callback) callback(success, res, success ? '已删除' : tips)
      }
    }
  )
}

/**
 * 改
 */
function updateAddress(addressObj, callback) {
  httpUtil.link(
    'addressedit',
    'POST',
    JSON.stringify(addressObj),
    true,
    function (success, res, tips) {
     
      if (success) {
        getAddressList({
          refreshReason: 'edit',
          id: parseInt(res.data.Content),
        },()=>{
          if (callback) callback(success, res, success ? '更新成功' : tips)
        })
      } else {
        if (callback) callback(success, res, success ? '更新成功' : tips)
      }
    }
  )
}

const addressManager =  {
  getAddressList: getAddressList,
  addAddress: addAddress,
  deleteAddress: deleteAddress,
  updateAddress: updateAddress,
}

export default addressManager;
